export default __webpack_public_path__ + "static/media/IMG-20240729-WA0017.f44f4c9b.jpg";